import DropdownMenu from "@atlaskit/dropdown-menu";
import type {ComponentProps} from "react";

export function AnankeDropdownMenu<T extends HTMLElement>(props: ComponentProps<typeof DropdownMenu<T>>) {
    return <DropdownMenu<T> {...props} />;
}
